function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.866 9.149c.488.468 1.28.468 1.768 0a1.166 1.166 0 000-1.698l-4.75-4.6a1.287 1.287 0 00-1.768 0l-4.75 4.6a1.166 1.166 0 000 1.698c.488.468 1.28.468 1.768 0L6 5.397 9.866 9.15z"
});

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12"
  }, props), _ref);
}

export default SvgChevron;